<template>
  <div v-if="isValidArray(labels)">
    <ul
      class="time-range__labels"
      :class="{ 'time-range__labels-mt': routeName === 'UsagePolicy' }"
    >
      <li
        v-for="(label, index) in labels"
        :key="`label-${index}`"
        class="time-range__label"
        :class="{ 'time-range__label--remove': remove }"
      >
        <span>{{ label.text }}</span>
        <button
          v-if="remove"
          type="button"
          class="time-range__btn"
          @click="handleRemoveTimeRange(label.key)"
        >
          <v-icon>close</v-icon>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import { renderLabels } from 'utils/timePolicy'

export default {
  name: 'Labels',
  props: {
    remove: {
      type: Boolean,
      default: false
    },
    timePolicyType: {
      type: String,
      required: true
    },
    intervals: {
      type: Array
    },
    setLabels: {
      type: Boolean
    }
  },
  computed: {
    routeName () {
      return this.$route.name
    }
  },
  data () {
    return {
      namespace: 'Views.UsagePolicyPage.timeRangeComboBox',
      labels: []
    }
  },
  methods: {
    isValidArray (val) {
      return isValidArray(val)
    },

    renderLabels () {
      this.labels = renderLabels(this, this.intervals, this.timePolicyType)
    },

    handleRemoveTimeRange (key) {
      if (key) {
        const [startTime, endTime] = key.split('-')
        this.$emit('removeTimeRange', { startTime, endTime })
      }
    }
  },
  watch: {
    setLabels () {
      this.renderLabels()
    }
  },
  mounted () {
    this.renderLabels()
  }
}
</script>

<style lang="scss" scoped>
.time-range__labels {
  list-style-type: none;
  margin: 0;
  padding: 0;

  &.time-range__labels-mt {
    margin: 12px 0 0;
  }
}

.time-range__label {
  align-items: center;
  background-color: $gray-3;
  border-radius: 16px;
  display: inline-flex;
  margin: 4px 8px 4px 0;
  padding: 4px 12px;

  &.time-range__label--remove {
    padding-right: 6px;
  }
}

.time-range__btn {
  align-items: center;
  background-color: $gray-5;
  border-radius: 50%;
  display: flex;
  height: 18px;
  justify-content: center;
  margin-left: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 18px;

  .v-icon {
    color: $gray-3;
    font-size: 14px;
    font-weight: bold;
  }

  &:hover {
    background-color: $gray-6;
  }
}
</style>
